import { vModelRadio as _vModelRadio, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e00f1d90")

_pushScopeId("data-v-e00f1d90")
const _hoisted_1 = { class: "group" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("label", {
      class: { active: $setup.value === 0 }
    }, [
      _withDirectives(_createVNode("input", {
        type: "radio",
        value: 0,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ($setup.value = $event))
      }, null, 512), [
        [_vModelRadio, $setup.value]
      ]),
      _createTextVNode(_toDisplayString(_ctx.$t("position.left")), 1 /* TEXT */)
    ], 2),
    _createVNode("label", {
      class: { active: $setup.value === 1 }
    }, [
      _withDirectives(_createVNode("input", {
        type: "radio",
        value: 1,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ($setup.value = $event))
      }, null, 512), [
        [_vModelRadio, $setup.value]
      ]),
      _createTextVNode(_toDisplayString(_ctx.$t("position.right")), 1 /* TEXT */)
    ], 2)
  ]))
})